const TRACKING_TOKEN_IDS = {
  dag: 'constellation-labs',
  dor: 'dor'
} as const;

export { TRACKING_TOKEN_IDS };
